import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "@/shared/lib/bff/client";

export interface RegisterPushTokenParams {
  token: string;
  platform: "ios" | "android";
  deviceName?: string | null;
}

export function registerPushToken(params: RegisterPushTokenParams) {
  return apiFetch<{ success: boolean }>("/api/notifications/tokens", {
    method: "POST",
    body: JSON.stringify(params),
  });
}

export function deletePushToken(token: string) {
  return apiFetch<{ success: boolean }>("/api/notifications/tokens", {
    method: "DELETE",
    body: JSON.stringify({ token }),
  });
}

export function useRegisterPushToken() {
  return useMutation({
    mutationFn: registerPushToken,
  });
}
